import { getStaticData } from 'utils/custom';

export default (status) => {
  const gameSessionStatuses = getStaticData('gameSessionStatuses');
  return Object.entries(gameSessionStatuses).find(([key, value]) => value === status)[0];
};
